import { registerEasyAccount } from "../actions/easyRewards";
import update from "../components/auth/login/update";
import {
    TOKEN_GENERATE_REQUEST,
    TOKEN_GENERATE_SUCCESS,
    TOKEN_GENERATE_FAILURE,
    SEARCH_MEMBER_REQUEST,
    SEARCH_MEMBER_SUCCESS,
    SEARCH_MEMBER_FAILURE,
    UPDATE_EASY_PROFILE_REQUEST,
    UPDATE_EASY_PROFILE_SUCCESS,
    UPDATE_EASY_PROFILE_FAILURE ,
    REGISTER_EASY_ACCOUNT_REQUEST,
    REGISTER_EASY_ACCOUNT_SUCCESS,
    REGISTER_EASY_ACCOUNT_FAILURE,
    SEARCH_CAPILLARY_MEMBER_REQUEST,
    SEARCH_CAPILLARY_MEMBER_SUCCESS,
    SEARCH_CAPILLARY_MEMBER_FAILURE,
    UPDATE_CAPILLARY_PROFILE_REQUEST,
    UPDATE_CAPILLARY_PROFILE_SUCCESS,
    UPDATE_CAPILLARY_PROFILE_FAILURE,
    REGISTER_CAPILLARY_ACCOUNT_REQUEST,
    REGISTER_CAPILLARY_ACCOUNT_SUCCESS,
    REGISTER_CAPILLARY_ACCOUNT_FAILURE,
    CLEAR_CAPILLARY_INFO

} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    tokenDetails: [],
    memberDetails : [],
    updateProfileDetails: [],
    registerEasyAccountDetails: [],
    capillaryMemberDetails : [],
    updateCapillaryProfileDetails: [],
    registerCapillaryAccountDetails: [],
    error: '',
};

export default function easyRewardsReducer(state = initialState, action) {
    // 
    switch (action.type) {
        case TOKEN_GENERATE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case TOKEN_GENERATE_SUCCESS: 
            return {
                ...state,
                // always replacing data
                
                tokenDetails: action.data,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case TOKEN_GENERATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

            case SEARCH_MEMBER_REQUEST:
            return {
                ...state,
                loading: true,
                memberDetails : []
            };
        case SEARCH_MEMBER_SUCCESS: 
            return {
                ...state,                          
                memberDetails: action.data,
                registerEasyAccountDetails:[],
                loading: false,
               
            };
        case SEARCH_MEMBER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
                memberDetails : []
            };
             case UPDATE_EASY_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case UPDATE_EASY_PROFILE_SUCCESS: 
            return {
                ...state,                          
                updateProfileDetails: action.data,
                loading: false,
            };
        case UPDATE_EASY_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
            };
             case REGISTER_EASY_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REGISTER_EASY_ACCOUNT_SUCCESS: 
            return {
                ...state,                          
                registerEasyAccountDetails: action.data,
                loading: false,
            };
        case REGISTER_EASY_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
            };
                case SEARCH_CAPILLARY_MEMBER_REQUEST:
            return {
                ...state,
                loading: true,
                capillaryMemberDetails : []
            };
        case SEARCH_CAPILLARY_MEMBER_SUCCESS:  
        console.log(action.data.data.status,'dddd') 
            return {
                ...state,                          
                capillaryMemberDetails:  action.data,
                registerCapillaryAccountDetails:[],
                loading: false,
            };
        case SEARCH_CAPILLARY_MEMBER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
                capillaryMemberDetails : []
            };
            case CLEAR_CAPILLARY_INFO:  
            return {
                ...state,                          
                capillaryMemberDetails: [],
                registerCapillaryAccountDetails:[],
                
            };
            
                case UPDATE_CAPILLARY_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
            };  
        case UPDATE_CAPILLARY_PROFILE_SUCCESS:
            return {
                ...state,                          
                updateCapillaryProfileDetails: action.data,
                loading: false,
            };
        case UPDATE_CAPILLARY_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
            };
                case REGISTER_CAPILLARY_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REGISTER_CAPILLARY_ACCOUNT_SUCCESS: 
            return {    
                ...state,                          
                registerCapillaryAccountDetails: action.data,
                loading: false,
            };  
        case REGISTER_CAPILLARY_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error.message,
            };
       
        default:
            return state;
    }
}
